import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import ListingCard from "./Listing/ListingCard";
import "./CollectionModal.scss";

function CollectionModal({
  open,
  collection,
  onClose,
  navigate,
  onOpenListingDetails,
  onToggleLike,
  onToggleSave,
  likedItems = [],
  savedItems = [],
  likesCount = {},
  commentsCounts = {},
}) {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    document.addEventListener("keydown", onKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open || !collection) return null;

  return createPortal(
    <div className="collection-modal">
      <div className="collection-modal__backdrop" onClick={onClose} />

      <div className="collection-modal__sheet">
        <div className="collection-modal__header">
          <button
            type="button"
            className="collection-modal__back"
            onClick={onClose}
          >
            ←
          </button>

          <div className="collection-modal__title">{collection.title}</div>

          <div className="collection-modal__spacer" />
        </div>

        <div className="collection-modal__content">
          <div className="collection-modal__grid">
            {collection.items.map((item) => {
              const postId = String(item?.listingId || item?.id || "");
              const isSaved = savedItems.includes(postId);
              const isLiked = likedItems.includes(postId);

              return (
                <div key={postId} className="collection-modal__item">
                  <ListingCard
                    item={item}
                    isSaved={isSaved}
                    isLiked={isLiked}
                    likesCount={likesCount[postId] || 0}
                    commentCount={commentsCounts[postId] || 0}
                    disableInitialTruthFetch={false}
                    onToggleLike={() => onToggleLike?.(item)}
                    onToggleSave={() => onToggleSave?.(item)}
                    onOpenListingDetails={() => onOpenListingDetails?.(item)}
                    navigate={navigate}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default CollectionModal;